const TUIChat = {
  '查看内容': 'Xem nội dung',
  '立即填写': 'Điền ngay',
  '已提交': 'Đã gửi',
  '不能为空': 'Không được để trống',
  '提交': 'Gửi',
  '撤回': 'Thu hồi',
  '删除': 'Xóa',
  '复制': 'Sao chép',
  '重新发送': 'Gửi lại',
  '转发': 'Chuyển tiếp',
  '引用': 'Trích dẫn',
  '打开': 'Mở',
  '已读': 'Đã đọc',
  '全部已读': 'Đã đọc hết',
  '人已读': ' đã đọc',
  '人未读': ' chưa đọc',
  '人关闭阅读状态': ' đóng trạng thái đọc',
  '消息详情': 'Thông tin tin nhắn',
  '关闭阅读状态': 'Đóng trạng thái đọc',
  '该消息不存在': 'Tin nhắn không tồn tại',
  '无法定位到原消息': 'Không thể xác định được tin nhắn gốc',
  '未读': 'Chưa đọc',
  '您': 'Bạn',
  '撤回了一条消息': 'Đã thu hồi một tin nhắn',
  '重新编辑': 'Chỉnh sửa lại',
  '我': 'Tôi',
  '查看更多': 'Xem thêm',
  '转发给': 'Chuyển tiếp đến',
  '请输入消息': 'Nhập tin nhắn',
  '描述': 'Mô tả',
  '经度': 'Kinh độ',
  '纬度': 'Vĩ độ',
  '自定义消息': 'Tin nhắn tùy chỉnh',
  '图片': '[hình ảnh]',
  '语音': '[âm thanh]',
  '视频': '[video]',
  '表情': '[biểu tượng cảm xúc]',
  '文件': '[tệp tin]',
  '自定义': '[tin nhắn tùy chỉnh]',
  '管理员开启全员禁言': 'Quản trị viên mở chế độ im lặng cho tất cả mọi người',
  '您已被管理员禁言': 'Bạn đã bị quản trị viên im lặng',
  '按Enter发送': 'Nhấn Enter để gửi tin nhắn',
  '单击下载': 'Nhấp để tải xuống',
  '下载':'tải về',
  '确认重发该消息？': 'Xác nhận gửi lại tin nhắn này?',
  '取消': 'Hủy',
  '确定': 'Xác nhận',
  '对方正在输入': 'Đang nhập tin...',
  '回到最新位置': '',
  '条新消息': ' tin nhắn mới',
  '点此投诉': 'Khiếu nại',
  '语音通话': 'Cuộc gọi thoại',
  '视频通话': 'Cuộc gọi video',
  '发起群语音': 'Bắt đầu cuộc gọi thoại nhóm',
  '发起群视频': 'Bắt đầu cuộc gọi video nhóm',
  '已接听': 'Đã trả lời',
  '拒绝通话': 'Từ chối cuộc gọi',
  '无应答': 'Không trả lời',
  '取消通话': 'Hủy cuộc gọi',
  '发起通话': 'Bắt đầu cuộc gọi',
  '结束群聊': 'Chỉnh sửa cuộc gọi nhóm',
  '通话时长': 'Thời gian gọi',
  '欢迎使用TUICallKit': 'Chào mừng đến với TUICallKit',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'Phát hiện rằng bạn chưa tích hợp TUI CallKit, vì vậy bạn không thể trải nghiệm chức năng cuộc gọi âm thanh và video.',
  '请点击': 'Vui lòng nhấp chuột',
  '集成TUICallKit': ' Tích hợp TUICallKit ',
  '开通腾讯实时音视频服务': 'Tích hợp Tencent Real-Time Communication',
  '进行体验': 'để trải nghiệm.',
  '您当前购买使用的套餐包暂未开通此功能': 'Gói dịch vụ mà bạn đang sử dụng không hỗ trợ tính năng này.',
  '系统消息': 'Bot',
  '转人工服务': 'Chuyển sang dịch vụ nhân tạo',
  '点击处理': 'Nhấp để xử lý',
  '发送失败': 'Gửi thất bại',
  '复制成功': 'Sao chép thành công',
  '回复': 'Trả lời',
  '回复详情': 'Chi tiết trả lời',
  '拒绝': 'Từ chối',
  '聊天记录': 'Lịch sử trò chuyện',
  '内容包含敏感词汇': 'Nội dung chứa từ ngữ nhạy cảm',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'Gói dịch vụ bạn đang sử dụng hiện chưa mở chức năng xác nhận đã đọc tin nhắn nhóm',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'Gói dịch vụ bạn đang sử dụng hiện chưa mở chức năng danh sách người dùng trực tuyến',
  '您有': 'Bạn có',
  '涉及敏感内容': 'Liên quan đến nội dung nhạy cảm',
  '申请加入': 'Đăng ký tham gia',
  '条回复': 'phản hồi',
  '条入群申请': 'đơn xin tham gia nhóm',
  '同意': 'Đồng ý',
  '图片消息失败,无效的图片格式': 'Gửi tin nhắn hình ảnh thất bại, định dạng hình ảnh không hợp lệ',
  '位置': 'Vị trí',
  '文件不存在,请检查文件路径是否正确': 'Tệp không tồn tại, vui lòng kiểm tra đường dẫn tệp có đúng không',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'Kích thước tệp vượt quá giới hạn, nếu tải lên tệp, giới hạn tối đa là 100MB',
  '文件消息失败,禁止发送违规封禁的文件': 'Gửi tin nhắn tệp thất bại, không được phép gửi tệp vi phạm',
  '无法查看': 'Không thể xem',
  '无法收听': 'Không thể nghe',
  '正在加载': 'Đang tải',
  '加载结束': 'Tải xong',
  '消息': 'Tin nhắn',
  '消息或者资料中文本存在敏感内容,发送失败': 'Tin nhắn hoặc nội dung văn bản chứa nội dung nhạy cảm, gửi thất bại',
  '消息长度超出限制,消息长度不要超过12K': 'Độ dài tin nhắn vượt quá giới hạn, độ dài tin nhắn không vượt quá 12K',
  '消息中图片存在敏感内容,发送失败': 'Tin nhắn chứa hình ảnh có nội dung nhạy cảm, gửi thất bại',
  '选择提醒的人': 'Chọn người để thông báo',
  '已过撤回时限': 'Quá thời hạn rút lại',
  '已拒绝': 'Đã từ chối',
  '已同意': 'Đã đồng ý',
  '引用失败': 'Trích dẫn thất bại',
  '翻译': 'Dịch',
  '转文字': 'Chuyển thành văn bản',
  '隐藏': 'Ẩn',
  '空': 'Trống',
  '文本包含本地审核拦截词': 'Văn bản chứa từ cấm kiểm duyệt địa phương',
  '按住说话': 'Nhấn và nói',
  '松开发送': 'Nhấc lên để gửi',
  '松手取消': 'Nhấc lên để hủy',
  '录音结束提醒': 'Ghi âm sẽ dừng sau',
  '语音播放失败': 'Phát lại âm thanh không thành công',
  '请检查麦克风访问权限': 'Vui lòng kiểm tra quyền truy cập microphone',
  '按压时间过短，请按压超过1秒': 'Thời gian nhấn quá ngắn, vui lòng nhấn giữ hơn 1 giây',
  '正在录音': 'Đang ghi âm',
  '继续上滑可取消': 'Tiếp tục vuốt lên để hủy',
  '松开手指 取消发送': 'Nhả tay để hủy gửi',
  '此机型暂不支持复制功能': 'Máy này tạm thời không hỗ trợ chức năng sao chép',
  '请开通翻译功能': 'Vui lòng bật chức năng dịch',
  '请开通语音转文字功能': 'Vui lòng bật chức năng chuyển đổi giọng nói thành văn bản',
  '翻译中': 'Đang dịch',
  '转换中': 'Đang chuyển đổi',
  '由IM提供翻译支持': 'Được hỗ trợ dịch bởi IM',
  '所有人': 'Tất cả mọi người',
  '已达到表情回应上限数量': 'Đã đạt đến số lượng giới hạn phản hồi biểu cảm',
  '等': 'và nhiều hơn nữa',
  '人': 'người',
  '返回': 'Quay lại',
  '关闭': 'Đóng',
  '多选': 'Chọn nhiều',
  '合并转发': 'Chuyển tiếp kết hợp',
  '逐条转发': 'Chuyển tiếp từng mục',
  '未选择消息': 'Chưa chọn tin nhắn',
  '草稿': 'Bản nháp',
  '文本': 'Văn bản',
  '音频': 'Âm thanh',
  '地理位置': 'Vị trí địa lý',
  '动画表情': 'Biểu cảm động',
  '群提示': 'Nhắc nhở nhóm',
  '群提示消息': 'Tin nhắn nhắc nhở nhóm',
  '机器人自定义消息': 'Tin nhắn tùy chỉnh của robot',
  '引用内容已撤回': 'Nội dung trích dẫn đã bị thu hồi',
  '群聊的聊天记录': 'Lịch sử trò chuyện nhóm',
  '和': 'và',
  '的聊天记录': 'của lịch sử trò chuyện',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'Vui lòng nâng cấp IMSDK lên phiên bản v2.10.1 hoặc cao hơn để xem tin nhắn này',
  '该群聊已被解散': 'Nhóm trò chuyện đã bị giải tán',
  '您已被管理员移出群聊': 'Bạn đã bị loại khỏi nhóm bởi quản trị viên',
  '您已退出该群聊': 'Bạn đã rời khỏi nhóm',
  '您已被禁止聊天': 'Bạn đã bị cấm trò chuyện',
  '按Enter发送，Ctrl+Enter换行': 'Nhấn Enter để gửi, Ctrl+Enter để xuống dòng',
  '账号被强制下线': 'Tài khoản bị buộc đăng xuất',
  '登录失败': 'Đăng nhập thất bại',
  '链接':'[Liên kết]',
};

export default TUIChat;
